module.exports = __webpack_public_path__ + "static/media/user.91e4294d.png";